import { createRouter, createWebHistory } from 'vue-router';
import AuthView from '@/views/AuthView.vue';
import LoginComponent from '@/components/Auth/LoginComponent.vue';
import RegisterComponent from '@/components/Auth/RegisterComponent.vue';
import PasswordResetComponent from '@/components/Auth/PasswordResetComponent.vue';
import AuthTeamComponent from '@/components/Auth/AuthTeamComponent.vue';
// eslint-disable-next-line import/no-cycle
import { checkIfRegisterDataCorrect } from '@/router/middleware/checkIfRegisterDataCorrect';
import SuccessEmailResetComponent from '@/components/Auth/SuccessEmailResetComponent.vue';
import { checkIfPasswordResetRequested } from '@/router/middleware/checkIfPasswordResetRequested';
import SuccessRegistrationComponent from '@/components/Auth/SuccessRegistrationComponent.vue';
import SuccessMcpOAuthComponent from '@/components/Auth/SuccessMcpOAuthComponent.vue';
import { checkIfRegisterSuccessful } from '@/router/middleware/checkIfRegisterSuccessful';
import TenantErrorView from '@/views/TenantErrorView.vue';
import NoDomainView from '@/views/NoDomainView.vue';
import HomeComponent from '@/components/Home/HomeComponent/HomeComponent.vue';
import KssTrackerComponent from '@/components/Home/KssCreator/KssTrackerComponent.vue';
import QuestionnaireView from '@/views/QuestionnaireView.vue';
import QuestionnaireComponent from '@/components/Home/QuestionnaireComponent/QuestionnaireComponent.vue';
import TeamAdministrationComponent from '@/components/Home/TeamAdministration/TeamAdministrationComponent.vue';
import UserAdministrationComponent from '@/components/Home/UserAdministration/UserAdministrationComponent.vue';
import AssessmentIntroComponent from '@/components/Home/QuestionnaireComponent/AssessmentIntroComponent.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import DashboardComponent from '@/components/Home/DashboardComponent/DashboardComponent.vue';
import ActivateAccountComponent from '@/components/Auth/ActivateAccountComponent.vue';
import EditProfileComponent from '@/components/Home/EditProfileComponent/EditProfileComponent.vue';
import TeamDashboardComponent from '@/components/Home/DashboardComponent/TeamDashboardComponent.vue';
import MyResultsDashboardComponent from '@/components/Home/DashboardComponent/MyResultsDashboardComponent.vue';
import TeamResultDashboardComponent from '@/components/Home/DashboardComponent/TeamResultDashboardComponent.vue';
import AdminComponent from '@/components/Home/AdminComponent/AdminComponent.vue';
import { checkIfUserHasPermission } from '@/router/middleware/checkIfUserHasPermission';
import { checkContentManagementAccess } from '@/router/middleware/checkContentManagementAccess';
import { TENANT_ROLE_ADMIN, TENANT_ROLE_COMPANY_SUPERUSER } from '@/services/enumService';
import AdminStepUpView from '@/components/Auth/AdminStepUpView.vue';
import KnowledgeDatabaseComponent from '@/components/Home/KnowledgeDatabaseComponent/KnowledgeDatabaseComponent.vue';
import AuthTagSelectComponent from '@/components/Auth/AuthTagSelectComponent.vue';
import SuccessPasswordChangeComponent from '@/components/Auth/SuccessPasswordChangeComponent.vue';
import { checkIfNewPasswordSuccessful } from '@/router/middleware/checkIfNewPasswordSuccessful';
import NewPasswordComponent from '@/components/Auth/NewPasswordComponent.vue';
import ManagementDashboard from '@/components/Home/ManagementDashboard/ManagementDashboardComponent.vue';
import HomeView from '../views/HomeView.vue';
import CustomerLayout from '@/components/CustomerApp/Layout/CustomerLayout.vue';
import PersonalGoalsComponent from '@/components/Home/PersonalGoalsComponent/PersonalGoalsComponent.vue';
import Mindset360Component from '@/components/Home/Mindset360Creator/Mindset360Component.vue';
import WorkshopComponent from '@/components/Home/WorkshopComponent/WorkshopComponent.vue';
import ReflexionGuidelineComponent from '@/components/Home/ReflexionGuidelineComponent/ReflexionGuidelineComponent.vue';
import TravelBuddyHistoryComponent from '@/components/Home/TravelBuddyHistoryComponent/TravelBuddyHistoryComponent.vue';
import CoachingChatComponent from '@/components/Home/Coaching/CoachingChatComponent.vue';
import CoachingProfileComponent from '@/components/Home/Coaching/CoachingProfileComponent.vue';
import DashboardLayout from '@/components/ContentManagement/DashboardLayout.vue';
import AssessmentsManager from '@/components/ContentManagement/views/AssessmentsManager.vue';
import EnumsManager from '@/components/ContentManagement/views/EnumsManager.vue';
import AssessmentDetails from '@/components/ContentManagement/views/AssessmentDetails.vue';
import DimensionDetails from '@/components/ContentManagement/views/DimensionDetails.vue';
import ConfigManager from '@/components/ContentManagement/views/ConfigManager.vue';
import UsersManager from '@/components/ContentManagement/views/UsersManager.vue';
import DimensionsManager from '@/components/ContentManagement/views/DimensionsManager.vue';
import DevTipsManager from '@/components/ContentManagement/DevTipsManager/DevTipsManagerComponent.vue';
import SchedulerManager from '@/components/ContentManagement/views/SchedulerManager.vue';
import LevelSystemManager from '@/components/ContentManagement/views/LevelSystemManager.vue';
import CoachingConfigManager from '@/components/ContentManagement/views/CoachingConfigManager.vue';
import CoachingScoreReviewManager from '@/components/ContentManagement/views/CoachingScoreReviewManager.vue';
import TravelBuddyManager from '@/components/ContentManagement/views/TravelBuddyManager.vue';
import DeveloperView from '@/components/ContentManagement/views/DeveloperView.vue';
import PersonalJourneyComponent from '@/components/Home/PersonalJourneyComponent/PersonalJourneyComponent.vue';
import TimelineManager from '@/components/ContentManagement/views/TimelineManager.vue';
import GatedFeaturePlaceholder from '@/components/CustomerApp/views/GatedFeaturePlaceholder.vue';
import { checkFeatureAccess } from '@/router/middleware/checkFeatureAccess';
import { refreshSessionFromPing } from '@/router/middleware/sessionRefresh';
import { shouldApplyTenantSessionGuard } from '@/router/middleware/tenantSessionGuard';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
import keycloak from '../../keycloak';

// Platform Admin imports
import PlatformLayout from '@/components/PlatformAdmin/PlatformLayout.vue';
import PlatformLogin from '@/components/PlatformAdmin/PlatformLogin.vue';
import PlatformVerify from '@/components/PlatformAdmin/PlatformVerify.vue';
import PlatformForgotPassword from '@/components/PlatformAdmin/PlatformForgotPassword.vue';
import PlatformResetPassword from '@/components/PlatformAdmin/PlatformResetPassword.vue';
import PlatformDashboard from '@/components/PlatformAdmin/views/PlatformDashboard.vue';
import TenantsManager from '@/components/PlatformAdmin/views/TenantsManager.vue';
import CreateTenant from '@/components/PlatformAdmin/views/CreateTenant.vue';
import TenantDetails from '@/components/PlatformAdmin/views/TenantDetails.vue';
import PlatformUsersManager from '@/components/PlatformAdmin/views/PlatformUsersManager.vue';
import AuditLogs from '@/components/PlatformAdmin/views/AuditLogs.vue';
import { checkPlatformAccess, checkPlatformAdminOnly } from '@/router/middleware/checkPlatformAccess';

const routes = [
  {
    path: '/',
    name: 'homeView',
    component: CustomerLayout,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'home',
        path: '',
        component: HomeComponent,
        meta: { titleKey: 'CustomerSidebar.home' },
      },
      {
        name: 'kssTracker',
        path: '/kss-tracker',
        component: KssTrackerComponent,
        props: (route) => ({ tab: route.query.tab }),
        meta: { titleKey: 'HeaderComponent.kssTracker', catalogKey: 'kssTracker' },
      },
      {
        name: 'personalGoals',
        path: '/personal-goals',
        component: PersonalGoalsComponent,
        meta: { titleKey: 'HeaderComponent.personalGoals', catalogKey: 'personalGoals' },
      },
      {
        name: '360mindset',
        path: '/external-evaluation',
        component: Mindset360Component,
        meta: { titleKey: 'HeaderComponent.360OMindset', catalogKey: 'externalEvaluation' },
      },
      {
        name: 'workshops',
        path: '/workshops',
        component: WorkshopComponent,
        meta: { titleKey: 'HeaderComponent.workshops', catalogKey: 'workshops' },
      },
      {
        name: 'personalJourney',
        path: '/personal-journey',
        component: PersonalJourneyComponent,
        meta: { titleKey: 'HeaderComponent.personalJourney', catalogKey: 'personalJourney' },
      },
      {
        name: 'reflexionGuideline',
        path: '/reflexionGuideline',
        component: ReflexionGuidelineComponent,
        meta: { titleKey: 'HeaderComponent.reflexionGuideline', catalogKey: 'reflexionGuideline' },
      },
      {
        name: 'travelBuddyHistory',
        path: '/travel-buddy-history',
        component: TravelBuddyHistoryComponent,
        meta: { titleKey: 'HeaderComponent.travelBuddyHistory', catalogKey: 'travelBuddyHistory' },
      },
      {
        name: 'llmCoaching',
        path: '/coaching',
        component: CoachingChatComponent,
        meta: { titleKey: 'HeaderComponent.llmCoaching', catalogKey: 'llmCoaching' },
      },
      {
        name: 'llmCoachingProfiling',
        path: '/coaching/profiling',
        component: CoachingChatComponent,
        props: { sessionMode: 'profiling' },
        meta: { titleKey: 'HeaderComponent.llmCoachingProfiling', catalogKey: 'llmCoaching' },
      },
      {
        name: 'llmCoachingProfile',
        path: '/coaching/profile',
        component: CoachingProfileComponent,
        meta: { titleKey: 'HeaderComponent.llmCoachingProfile', catalogKey: 'llmCoachingProfile' },
      },
      {
        name: 'teamAdministration',
        path: 'team-administration',
        component: TeamAdministrationComponent,
        beforeEnter: (to, from, next) => checkIfUserHasPermission(to, from, next, [TENANT_ROLE_ADMIN, TENANT_ROLE_COMPANY_SUPERUSER]),
        meta: { titleKey: 'HeaderComponent.administration', catalogKey: 'teamAdministration' },
      },
      {
        name: 'ManagementDashboard',
        path: '/management-dashboard',
        component: ManagementDashboard,
        beforeEnter: (to, from, next) => {
          if (import.meta.env.VITE_MGMTDB === 'true') {
            checkIfUserHasPermission(to, from, next, [TENANT_ROLE_ADMIN]);
          } else {
            next('/');
          }
        },
        meta: { titleKey: 'HeaderComponent.mngDashboard', catalogKey: 'managementDashboard' },
      },
      {
        name: 'userAdministration',
        path: 'user-administration',
        component: UserAdministrationComponent,
        beforeEnter: (to, from, next) => checkIfUserHasPermission(to, from, next, [TENANT_ROLE_ADMIN, TENANT_ROLE_COMPANY_SUPERUSER]),
        meta: { titleKey: 'BreadCrumbs.useradministration', catalogKey: 'userAdministration' },
      },
      {
        name: 'dashboard',
        path: 'dashboard',
        component: DashboardComponent,
        props: (route) => ({ tab: route.query.tab }),
        meta: { titleKey: 'BreadCrumbs.dashboard' },
      },
      {
        name: 'knowledgeDatabase',
        path: 'knowledge-database',
        component: KnowledgeDatabaseComponent,
        meta: { titleKey: 'HeaderComponent.knowledgeDatabase', catalogKey: 'knowledgeDatabase' },
      },
      {
        name: 'teamDashboard',
        path: 'team-dashboard',
        component: TeamDashboardComponent,
        props: (route) => ({ tab: route.query.tab }),
        meta: { titleKey: 'BreadCrumbs.teamDashboard' },
      },
      {
        name: 'myResultsDashboard',
        path: 'my-results-dashboard',
        component: MyResultsDashboardComponent,
        props: (route) => ({ tab: route.query.tab }),
        meta: { titleKey: 'HeaderComponent.yourOwnResults', catalogKey: 'myResults' },
      },
      {
        name: 'teamResultsDashboard',
        path: 'team-results-dashboard',
        component: TeamResultDashboardComponent,
        props: (route) => ({ tab: route.query.tab }),
        meta: { titleKey: 'HeaderComponent.teamResults', catalogKey: 'teamResults' },
      },
      {
        name: 'gatedFeature',
        path: 'gated-feature',
        component: GatedFeaturePlaceholder,
        meta: { titleKey: 'GatedFeature.title', requiresAuth: true },
      },
      {
        name: 'editProfile',
        path: 'edit-profile',
        component: EditProfileComponent,
        meta: { titleKey: 'HeaderComponent.goToProfile' },
      },
      {
        name: 'admin',
        path: 'admin',
        component: AdminComponent,
        beforeEnter: (to, from, next) => checkIfUserHasPermission(to, from, next, [TENANT_ROLE_ADMIN]),
        meta: { titleKey: 'HeaderComponent.admin' },
      },
      {
        name: 'assessmentIntro',
        path: 'assessment-intro',
        component: AssessmentIntroComponent,
        props: (route) => ({ id: route.query.id }),
        meta: { titleKey: 'BreadCrumbs.evaluation' },
      },
      {
        name: 'questionnaire',
        path: 'questionnaire',
        component: QuestionnaireComponent,
        props: (route) => ({ id: route.query.id }),
        meta: { titleKey: 'BreadCrumbs.evaluation' },
      },
      {
        path: 'oim-intro',
        redirect: (to) => ({ path: 'assessment-intro', query: to.query }),
      },
      {
        path: 'oim-intro',
        redirect: (to) => ({ path: 'assessment-intro', query: to.query }),
      },
    ],
  },
  {
    name: 'evaluation',
    path: '/evaluation/questionnaire',
    component: QuestionnaireView,
    children: [
      {
        name: 'questionnaireEvaluation',
        path: '',
        component: QuestionnaireComponent,
        props: (route) => ({ id: route.query.id }),
      },
    ],
  },
  {
    name: 'evaluationAssessmentIntro',
    path: '/evaluation/assessment-intro',
    component: QuestionnaireView,
    children: [
      {
        path: '',
        component: AssessmentIntroComponent,
        props: (route) => ({ id: route.query.id }),
      },
    ],
  },
  {
    path: '/auth/login',
    redirect: (to) => ({ path: '/auth', query: to.query }),
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthView,
    children: [
      {
        name: 'login',
        path: '',
        component: LoginComponent,
      },
      {
        name: 'register',
        path: '/auth/register',
        component: RegisterComponent,
      },
      {
        name: 'passwordReset',
        path: '/auth/password-reset',
        component: PasswordResetComponent,
      },
      {
        name: 'newPassword',
        path: '/auth/new-password',
        component: NewPasswordComponent,
        props: (route) => ({
          validationKey: route.query.key,
          email: route.query.mail,
        }),
      },
      {
        name: 'teamSelection',
        path: '/auth/team-selection',
        component: AuthTeamComponent,
        beforeEnter: checkIfRegisterDataCorrect,
      },
      {
        name: 'tagSelection',
        path: '/auth/tag-selection',
        component: AuthTagSelectComponent,
        beforeEnter: checkIfRegisterDataCorrect,
      },
      {
        name: 'passwordResetSuccess',
        path: '/auth/password-reset-success',
        component: SuccessEmailResetComponent,
        beforeEnter: checkIfPasswordResetRequested,
      },
      {
        name: 'mcpOAuthSuccess',
        path: '/auth/oauth-success',
        component: SuccessMcpOAuthComponent,
      },
      {
        name: 'adminStepUp',
        path: '/auth/admin-step-up',
        component: AdminStepUpView,
      },
      {
        name: 'registerSuccessful',
        path: '/auth/register-success',
        component: SuccessRegistrationComponent,
        beforeEnter: checkIfRegisterSuccessful,
      },
      {
        name: 'newPasswordSuccess',
        path: '/auth/new-password-success',
        component: SuccessPasswordChangeComponent,
        beforeEnter: checkIfNewPasswordSuccessful,
      },
      {
        name: 'userActivation',
        path: '/auth/account-activation',
        component: ActivateAccountComponent,
        props: (route) => ({
          email: route.query.mail,
          validationKey: route.query.key,
        }),
      },
    ],
  },
  {
    path: '/impressum',
    name: 'impressum',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ImpressumView" */ '../views/ImpressumView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ImpressumView" */ '../views/PrivacyView.vue'),
  },
  {
    name: 'ContentManagement',
    path: '/contentManagement',
    component: DashboardLayout,
    meta: { requiresAuth: true },
    beforeEnter: checkContentManagementAccess,
    children: [
      {
        path: '/contentManagement/enums',
        name: 'EnumsManager',
        component: EnumsManager,
      },
      {
        path: '/contentManagement/dimensions/:id',
        name: 'DimensionDetails',
        component: DimensionDetails,
      },
      {
        path: '/contentManagement/dimensions',
        name: 'DimensionsManager',
        component: DimensionsManager,
      },
      {
        path: '/contentManagement/dev-tips',
        name: 'DevTipsManager',
        component: DevTipsManager,
      },
      {
        path: '/contentManagement/assessments/:id',
        name: 'AssessmentDetails',
        component: AssessmentDetails,
      },
      {
        path: '/contentManagement/assessments',
        name: 'AssessmentsManager',
        component: AssessmentsManager,
      },
      {
        path: '/contentManagement/templates',
        name: 'TemplatesManager',
        component: () => import('@/components/ContentManagement/views/TemplatesManager.vue'),
      },
      {
        path: '/contentManagement/config',
        name: 'ConfigManager',
        component: ConfigManager,
      },
      {
        path: '/contentManagement/users',
        name: 'UsersManager',
        component: UsersManager,
      },
      {
        path: '/contentManagement/user-assessments',
        name: 'UserAssessments',
        component: () => import('@/components/ContentManagement/views/UserAssessments.vue'),
      },
      {
        path: '/contentManagement/external-evaluation',
        name: 'AdminExternalEvaluation',
        component: () => import('@/components/ContentManagement/views/AdminExternalEvaluation.vue'),
      },
      {
        path: '/contentManagement/kss-series',
        name: 'KssSeriesManager',
        component: () => import('@/components/ContentManagement/views/KssSeriesManager.vue'),
      },
      {
        path: '/contentManagement/user-feedback',
        name: 'UserFeedbackManager',
        component: () => import('@/components/ContentManagement/views/UserFeedbackManager.vue'),
      },
      {
        path: '/contentManagement/scheduler',
        name: 'SchedulerManager',
        component: SchedulerManager,
      },
      {
        path: '/contentManagement/coaching-config',
        name: 'CoachingConfigManager',
        component: CoachingConfigManager,
      },
      {
        path: '/contentManagement/coaching-score-review',
        name: 'CoachingScoreReviewManager',
        component: CoachingScoreReviewManager,
      },
      {
        path: '/contentManagement/level-system',
        name: 'LevelSystemManager',
        component: LevelSystemManager,
      },
      {
        path: '/contentManagement/travel-buddy',
        name: 'TravelBuddyManager',
        component: TravelBuddyManager,
      },
      {
        path: '/contentManagement/timeline',
        name: 'TimelineManager',
        component: TimelineManager,
      },
      {
        path: '/contentManagement/content',
        name: 'TenantContent',
        component: () => import('@/components/ContentManagement/views/TenantContent.vue'),
      },
      {
        path: '/contentManagement/features',
        name: 'TenantFeatures',
        component: () => import('@/components/ContentManagement/views/TenantFeatures.vue'),
      },
      {
        path: '/contentManagement/data-transfer',
        name: 'DataTransfer',
        component: () => import('@/components/ContentManagement/views/DataTransfer.vue'),
        beforeEnter: (to, from, next) => {
          // Only allow in single-tenant mode
          const isMultiTenant = localStorage.getItem('multiTenantEnabled') === 'true';
          if (isMultiTenant) {
            next('/contentManagement/assessments');
          } else {
            next();
          }
        },
      },
      {
        path: '/contentManagement/developer',
        name: 'DeveloperView',
        component: DeveloperView,
      },
    ],
  },
  // Platform Login Route (for admin.localhost)
  {
    name: 'PlatformLogin',
    path: '/platform/login',
    component: PlatformLogin,
    meta: { requiresAuth: false },
  },
  {
    name: 'PlatformVerify',
    path: '/platform/verify',
    component: PlatformVerify,
    meta: { requiresAuth: false },
  },
  {
    name: 'PlatformForgotPassword',
    path: '/platform/forgot-password',
    component: PlatformForgotPassword,
    meta: { requiresAuth: false },
  },
  {
    name: 'PlatformResetPassword',
    path: '/platform/reset-password',
    component: PlatformResetPassword,
    meta: { requiresAuth: false },
  },
  // Platform Admin Routes (only available in multi-tenant mode)
  {
    name: 'PlatformAdmin',
    path: '/platform',
    component: PlatformLayout,
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
    beforeEnter: checkPlatformAccess,
    children: [
      {
        path: '',
        name: 'PlatformDashboard',
        component: PlatformDashboard,
      },
      {
        path: 'tenants',
        name: 'TenantsManager',
        component: TenantsManager,
      },
      {
        path: 'tenants/new',
        name: 'CreateTenant',
        component: CreateTenant,
        beforeEnter: checkPlatformAdminOnly,
      },
      {
        path: 'tenants/:slug',
        name: 'TenantDetails',
        component: TenantDetails,
        props: true,
      },
      {
        path: 'tenants/:slug/edit',
        name: 'TenantEdit',
        component: () => import('@/components/PlatformAdmin/views/EditTenant.vue'),
        props: true,
      },
      {
        path: 'users',
        name: 'PlatformUsersManager',
        component: PlatformUsersManager,
        beforeEnter: checkPlatformAdminOnly,
      },
      {
        path: 'audit',
        name: 'AuditLogs',
        component: AuditLogs,
      },
      {
        path: 'settings',
        name: 'PlatformSettings',
        component: () => import('@/components/PlatformAdmin/views/PlatformSettings.vue'),
        beforeEnter: checkPlatformAdminOnly,
      },
      {
        path: 'mcp-tokens',
        name: 'PlatformMcpTokens',
        component: () => import('@/components/PlatformAdmin/views/PlatformMcpTokens.vue'),
        beforeEnter: checkPlatformAdminOnly,
      },
      {
        path: 'mcp-prompts',
        name: 'PlatformMcpPrompts',
        component: () => import('@/components/PlatformAdmin/views/PlatformMcpPrompts.vue'),
        beforeEnter: checkPlatformAdminOnly,
      },
      {
        path: 'templates',
        name: 'GeneralTemplatesManager',
        component: () => import('@/components/PlatformAdmin/views/GeneralTemplatesManager.vue'),
        beforeEnter: checkPlatformAdminOnly,
      },
    ],
  },
  // No Domain Route (displayed when accessing bare domain without subdomain)
  {
    path: '/no-domain',
    name: 'NoDomain',
    component: NoDomainView,
    meta: { requiresAuth: false, skipTenantValidation: true },
  },
  // Tenant Error Route (displayed when tenant validation fails)
  {
    path: '/tenant-error',
    name: 'TenantError',
    component: TenantErrorView,
    props: (route) => ({
      errorType: route.query.error || 'TENANT_NOT_FOUND',
      tenantSlug: route.query.tenant || '',
      customMessage: route.query.message || '',
    }),
    meta: { requiresAuth: false, skipTenantValidation: true },
  },
  {
    path: '/:catchAll(.*)',
    component: NotFoundView,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || '/'),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!shouldApplyTenantSessionGuard(to)) {
    next();
    return;
  }

  if (import.meta.env.VITE_KEYCLOAK === 'true') {
    if (!keycloak.authenticated) {
      next('/auth');
      return;
    }
    try {
      await refreshSessionFromPing();
    } catch {
      next('/auth');
      return;
    }
    checkFeatureAccess(to, from, next);
    return;
  }

  if (!store.state.auth.token) {
    next('/auth');
    return;
  }

  try {
    await refreshSessionFromPing();
  } catch {
    next('/auth');
    return;
  }

  checkFeatureAccess(to, from, next);
});

export default router;
